import { render } from "./CustomerChannels.vue?vue&type=template&id=d2c086d6"
import script from "./CustomerChannels.vue?vue&type=script&lang=js"
export * from "./CustomerChannels.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__